// Module
var code = "<a class=\"btn-default-general btn-default-primary\" href=\"javascript:history.back()\" ng-if=\"!toLocation\"> Done </a> <a class=\"btn-default-general btn-default-primary\" ui-sref=\"{{toLocation}}\" ng-if=\"toLocation\"> Done </a> ";
// Exports
module.exports = code;